/* eslint-disable no-script-url, jsx-a11y/anchor-is-valid */
import React from "react";
import "./Pagination.css";

let prev = 0;
let next = 0;
let last = 0;
let first = 1;
let currentPage = 1;
export default class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalRecords: this.props.totalRecords,
      pageSize: this.props.pageSize,
      isRefresh: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleLastClick = this.handleLastClick.bind(this);
    this.handleFirstClick = this.handleFirstClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.totalRecords !== prevProps.totalRecords) {
      currentPage = 1;
    }
  }
  handleClick(event) {
    currentPage = Number(event.target.id);
    this.props.onChildClick(event.target.id);
    return false;
  }
  handleLastClick(event) {
    currentPage = last;
    this.props.onChildClick(last);
    return false;
  }
  handleNextClick(event) {
    currentPage = next;
    this.props.onChildClick(next);
    return false;
  }
  handleFirstClick(event) {
    currentPage = first;
    this.props.onChildClick(1);
    return false;
  }
  handlePrevClick(event) {
    currentPage = prev;
    this.props.onChildClick(prev);
    return false;
  }
  render() {
    const { pageSize } = this.state;
    const { totalRecords } = this.props;

    const isVisible = totalRecords > pageSize ? true : false;

    prev = currentPage > 0 ? currentPage - 1 : 0;
    last = Math.ceil(totalRecords / pageSize);
    next = last === currentPage ? currentPage : currentPage + 1;

    let totalPage = Math.ceil(totalRecords / pageSize);
    let pageNumbers = [];
    for (let i = 1; i <= totalPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <div className="dvPaging">
        {isVisible ? (
          <ul class="pagination justify-content-center">
            {prev === 0 ? (
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleFirstClick();
                  }}
                >
                  First
                </a>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  onClick={this.handlePrevClick}
                  id={prev}
                  href="Javascript:void();"
                >
                  First
                </a>
              </li>
            )}
            {prev === 0 ? (
              <li class="page-item disabled">
                <a class="page-link" href="Javascript:void();">
                  Previous
                </a>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  onClick={this.handleFirstClick}
                  id={prev}
                  href="Javascript:void();"
                >
                  Previous
                </a>
              </li>
            )}
            {pageNumbers.map((number, index) => {
              return (
                <li
                  className={`page-item ${
                    pageNumbers[currentPage - 1] === number ? "active" : ""
                  }`}
                >
                  <a
                    class="page-link"
                    href="Javascript:void();"
                    onClick={this.handleClick}
                    key={number}
                    id={number}
                  >
                    {number}
                  </a>
                </li>
              );
            })}
            {currentPage === last ? (
              <li class="page-item disabled">
                <a class="page-link disabled" href="Javascript:void();">
                  Next
                </a>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  onClick={this.handleNextClick}
                  id={pageNumbers[currentPage]}
                  href="Javascript:void();"
                >
                  Next
                </a>
              </li>
            )}
            {currentPage === last ? (
              <li class="page-item disabled">
                <a class="page-link disabled" href="Javascript:void();">
                  Last
                </a>
              </li>
            ) : (
              <li class="page-item">
                <a
                  class="page-link"
                  onClick={this.handleLastClick}
                  id={pageNumbers[currentPage]}
                  href="Javascript:void();"
                >
                  Last
                </a>
              </li>
            )}
          </ul>
        ) : null}
      </div>
    );
  }
}
